import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Component pages
import { DashboardComponent } from "./dashboards/dashboard/dashboard.component";
import { ItemComponent } from "./item/item.component";
import { SupplierComponent } from "./supplier/supplier.component";
import { PriceHistoriesComponent } from "./price-histories/price-histories.component";
import { PurchaseOrdersComponent } from './purchase-orders/purchase-orders.component';
import { MaterialAcceptanceListComponent } from './material-acceptances/list/material-acceptance-list.component';
import { QualityChecksComponent } from './quality-checks/quality-checks.component';
import { InventoryComponent } from './inventory/inventory.component';
import { MaterialConsumptionComponent } from './material-consumption/material-consumption.component';
import { InventoryTransactionsComponent } from './inventory-transactions/inventory-transactions.component';
import { DemandsComponent } from './demands/demands.component';

const routes: Routes = [
    {
        path: "",
        component: PurchaseOrdersComponent
    },
    {
        path: "item",
        component: ItemComponent
    },
    {
        path: "supplier",
        component: SupplierComponent
    },
    {
        path: "price-histories",
        component: PriceHistoriesComponent
    },
    {
      path: '', loadChildren: () => import('./dashboards/dashboards.module').then(m => m.DashboardsModule)
    },
    {
      path: 'apps', loadChildren: () => import('./apps/apps.module').then(m => m.AppsModule)
    },
    {
      path: 'ecommerce', loadChildren: () => import('./ecommerce/ecommerce.module').then(m => m.EcommerceModule)
    },
    // {
    //   path: 'projects', loadChildren: () => import('./projects/projects.module').then(m => m.ProjectsModule)
    // },
    // {
    //   path: 'tasks', loadChildren: () => import('./tasks/tasks.module').then(m => m.TasksModule)
    // },
    // {
    //   path: 'crm', loadChildren: () => import('./crm/crm.module').then(m => m.CrmModule)
    // },
    // {
    //   path: 'crypto', loadChildren: () => import('./crypto/crypto.module').then(m => m.CryptoModule)
    // },
    {
      path: 'invoices', loadChildren: () => import('./invoices/invoices.module').then(m => m.InvoicesModule)
    },
    { path: 'purchase-orders', component: PurchaseOrdersComponent },
    { path: 'material-acceptances', component: MaterialAcceptanceListComponent },
    { path: 'quality-checks', component: QualityChecksComponent },
    { path: 'inventory', component: InventoryComponent },
    { path: 'material-consumption', component: MaterialConsumptionComponent },
    { path: 'transaction-history', component: InventoryTransactionsComponent },
    { path: 'demands', component: DemandsComponent },
    {
      path: 'pages', loadChildren: () => import('./extrapages/extraspages.module').then(m => m.ExtraspagesModule)
    },
    { path: 'ui', loadChildren: () => import('./ui/ui.module').then(m => m.UiModule) },
    {
      path: 'advance-ui', loadChildren: () => import('./advance-ui/advance-ui.module').then(m => m.AdvanceUiModule)
    },
    {
      path: 'forms', loadChildren: () => import('./form/form.module').then(m => m.FormModule)
    },
    {
      path: 'tables', loadChildren: () => import('./tables/tables.module').then(m => m.TablesModule)
    },
    // {
    //   path: 'charts', loadChildren: () => import('./charts/charts.module').then(m => m.ChartsModule)
    // },
    {
      path: 'icons', loadChildren: () => import('./icons/icons.module').then(m => m.IconsModule)
    },
    // {
    //   path: 'maps', loadChildren: () => import('./maps/maps.module').then(m => m.MapsModule)
    // },
    // {
    //   path: 'marletplace', loadChildren: () => import('./nft-marketplace/nft-marketplace.module').then(m => m.NftMarketplaceModule)
    // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
